import React, { useEffect } from 'react';

import { platform } from '@constants/config';

import LibraryContainer from '@containers/Library/LibraryContainer';

import { AnalyticsService, SCREEN_NAME } from '@webServices/AnalyticsService';
import FeatureCardSection from './FeatureCardSection';
import Footer from './Footer';
import GetStartedSection from './GetStartedSection';
import GuestCourseCard from './GuestCourseCard';
import GuestCourseList from './GuestCourseList';
import GuestHeader from './GuestHeader';
import OpenLibrarySection from './OpenLibrarySection';
import ReasonSection from './ReasonSection';
import './styles.less';
import GuestOverview from './GuestOverview';

const GuestView = () => {

    useEffect(function onMount() {
        AnalyticsService.logEvent(AnalyticsService.getPageViewEvent(), { screen_name: SCREEN_NAME.GUEST_HOME });
    }, []);

    return (
        <div className="guest-view">
            {/* @ts-ignore */}
            {/* Components are commented for later use */}
            {platform.WITP ? null : <GuestHeader />}
            {/* <GetStartedSection />
            <FeatureCardSection /> */}
            {/* <GuestCourseCard /> */}
            <GuestOverview />
            {/* <FeatureCardSection /> */}
            {/* <ReasonSection /> */}
            {platform.WITP ? <GuestCourseList />: null}
            {/* {platform.WITP ? <OpenLibrarySection /> : null} */}
            <LibraryContainer />
            <Footer />
        </div>
    )
};

export default GuestView;
